import { Mic, StopCircle } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";

const SpeechToTextButton = ({ onTranscript }) => {
    const [isListening, setIsListening] = useState(false);
    const recognitionRef = useRef(null);

    useEffect(() => {
        if ('webkitSpeechRecognition' in window) {
            const SpeechRecognition = window.webkitSpeechRecognition;
            recognitionRef.current = new SpeechRecognition();
            recognitionRef.current.continuous = false;
            recognitionRef.current.interimResults = false;
            recognitionRef.current.lang = 'en-US';

            recognitionRef.current.onresult = (event) => {
                const transcript = event?.results[0][0]?.transcript;
                onTranscript(transcript);
            };

            recognitionRef.current.onerror = (event) => {
                console.error("Speech recognition error", event?.error);
                setIsListening(false);
            };

            recognitionRef.current.onend = () => {
                setIsListening(false);
            };
        }
    }, [onTranscript]);

    const handleSpeechToText = () => {
        if (isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
        } else {
            recognitionRef.current.start();
            setIsListening(true);
        }
    };

    return (
        <div className="w-100 m-b-10 m-t-10 flex flex-h-center">
            <div className="w-100 flex-h-center">
                <button onClick={handleSpeechToText} className="speech-btn w-100 btn">
                    {isListening ? <div className="flex flex-h-center flex-v-center"> <span className="m-r-10">Stop Listening</span> <div className="text-red"><StopCircle color="white"/></div></div> : <div className="flex flex-v-center flex-h-center"> <span className="m-r-10">Start Speaking</span> <div ><Mic color="white"/></div></div>}
                </button>
            </div>

        </div>

    );
};

export default SpeechToTextButton;
